<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-cascades"></i> 关于</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="height: 400px">
            <!-- <div class="plugins-tips" style="width: 50%; float: left">KJ927煤炭产量管理系统</div>
            <div><img :src="imgUrl" style="width: 50%; float: left" /></div> -->
            <!-- <div class="divA"><img :src="imgUrl" style="width: 100%; float: left" /></div> -->
            <div class="divB">
                <h3>KJ927煤炭产量管理系统</h3>
                <!-- <div>电话:0516-82157288</div>
                <div>传真:0516-83992378</div> -->
                <div>后台版本:{{version}}</div>
                <div>web版本:{{frontversion}}</div>
                <!-- <div>公司名称:徐州圣能科技有限公司</div>
                <div>地址:江苏省徐州市云龙区新城区绿地商务城蓝海二期B座-18F</div> -->
            </div>
        </div>
    </div>
</template>

<script>
// import imgUrl from '../../../screenshots/apply.png';
// import imgUrl from '../../assets/img/about1.jpg';
export default {
    name: 'userInfo',
    data() {
        return {
            // imgUrl,
            version:"",
            frontversion:"1.6.0.6"
        };
    },
    created() {
        this.getVersion();
    },
    methods: {
        getVersion() {
            var serach = {};
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.msg;
                        this.version=d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        }
    }
};
</script>

<style scoped>
.divA {
    float: left;
    width: 30%;
    /* border: 1px solid #fbacce; */
}
.divB {
    float: left;
    width: 48%;
    /* border: 1px solid #fbacce; */
    margin-left: 30px;
}
.divB div,
h3 {
    margin-bottom: 30px;
}
</style>